





















































































import DictMixin from '@/mixins/dict-mixin';
import MenuMixin from '@/mixins/menu-mixin';
import DimensionServices from '@/services/dimension';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
import DimensionForm6 from './dimension-form-6.vue';
import RefData from './ref-data.vue';

@Component({
  components: { DimensionForm6, RefData }
})
export default class DimensionDetail extends mixins(DictMixin, MenuMixin) {
  dimSrv = new DimensionServices();
  visible = false;
  id: any = 0;
  info = {};

  created() {
    this.id = this.$route.query.id;
  }

  @Watch('$route')
  onRouteChange() {
    this.id = this.$route.query.id;
    this.onIdChange();
  }

  dimFieldList: any[] = [];
  dimSyncDefs: any = {};
  inputdataConfig: any[] = [];
  itemList: any[] = [];
  @Watch('id')
  async onIdChange() {
    if (!this.id || this.$route.path != '/decision/dimension/detail') return false;
    this.spinning = true;
    let res = await this.dimSrv.getInfo(this.id);
    this.spinning = false;
    this.info = res.sysDim;
    this.dimFieldList = res.dimFieldList;
    this.dimSyncDefs = res.dimSyncDefs;
    this.inputdataConfig = JSON.parse(this.dimSyncDefs.syncConfig || '[]');
    this.dimSyncDefs.jobConfig = JSON.parse(this.dimSyncDefs.jobConfig);
  }
}
